import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import Layout from './components/Layout.jsx';
import LandingPage from './pages/LandingPage.jsx';

// 路由级 lazy load —— 各 page 独立 chunk
// LandingPage 留主 chunk（首屏立即显示，不要 spinner 闪烁）
const EvaluatePage           = lazy(() => import('./pages/EvaluatePage.jsx'));
const BatchEvaluatePage      = lazy(() => import('./pages/BatchEvaluatePage.jsx'));
const TrackerPage            = lazy(() => import('./pages/TrackerPage.jsx'));
const ApplicationDetailPage  = lazy(() => import('./pages/ApplicationDetailPage.jsx'));
const ProfilePage            = lazy(() => import('./pages/ProfilePage.jsx'));
const ResumePage             = lazy(() => import('./pages/ResumePage.jsx'));
const AuthCallbackPage       = lazy(() => import('./pages/AuthCallbackPage.jsx'));
const NotFoundPage           = lazy(() => import('./pages/NotFoundPage.jsx'));

function PageFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-ink-400">
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<LandingPage />} />
        <Route
          path="evaluate"
          element={<Suspense fallback={<PageFallback />}><EvaluatePage /></Suspense>}
        />
        <Route
          path="batch"
          element={<Suspense fallback={<PageFallback />}><BatchEvaluatePage /></Suspense>}
        />
        <Route
          path="tracker"
          element={<Suspense fallback={<PageFallback />}><TrackerPage /></Suspense>}
        />
        <Route
          path="tracker/:id"
          element={<Suspense fallback={<PageFallback />}><ApplicationDetailPage /></Suspense>}
        />
        <Route
          path="profile"
          element={<Suspense fallback={<PageFallback />}><ProfilePage /></Suspense>}
        />
        <Route
          path="resume"
          element={<Suspense fallback={<PageFallback />}><ResumePage /></Suspense>}
        />
        <Route
          path="auth/callback"
          element={<Suspense fallback={<PageFallback />}><AuthCallbackPage /></Suspense>}
        />
        <Route
          path="*"
          element={<Suspense fallback={<PageFallback />}><NotFoundPage /></Suspense>}
        />
      </Route>
    </Routes>
  );
}
